import { SurveyTab } from './constants';
export var SurveyStarLabel;
(function (SurveyStarLabel) {
    SurveyStarLabel["VeryPoor"] = "call-quality-survey.star.very-poor";
    SurveyStarLabel["Poor"] = "call-quality-survey.star.poor";
    SurveyStarLabel["Average"] = "call-quality-survey.star.average";
    SurveyStarLabel["Good"] = "call-quality-survey.star.good";
    SurveyStarLabel["Great"] = "call-quality-survey.star.great";
})(SurveyStarLabel || (SurveyStarLabel = {}));
export var SurveyStarValue;
(function (SurveyStarValue) {
    SurveyStarValue[SurveyStarValue["VeryPoor"] = 1] = "VeryPoor";
    SurveyStarValue[SurveyStarValue["Poor"] = 2] = "Poor";
    SurveyStarValue[SurveyStarValue["Average"] = 3] = "Average";
    SurveyStarValue[SurveyStarValue["Good"] = 4] = "Good";
    SurveyStarValue[SurveyStarValue["Great"] = 5] = "Great";
})(SurveyStarValue || (SurveyStarValue = {}));
export const SurveyData = {
    video: {
        no_video: {
            value: false,
            title: 'call-quality-survey.video.cantsee',
        },
        choppy: {
            value: false,
            title: 'call-quality-survey.video.choppy-blurry',
        },
        no_sync: {
            value: false,
            title: 'call-quality-survey.video.not-sync',
        },
        camera_not_work: {
            value: false,
            title: 'call-quality-survey.video.camera',
        },
        restart: { value: false, title: 'call-quality-survey.video.restart' },
        drop: { value: false, title: 'call-quality-survey.video.drop' },
        camera_stopped: {
            value: false,
            title: 'call-quality-survey.video.camera-stop',
        },
    },
    audio: {
        echo: { value: false, title: 'call-quality-survey.audio.echo' },
        audio_break: { value: false, title: 'call-quality-survey.audio.break' },
        delay_sound: { value: false, title: 'call-quality-survey.audio.delay' },
        people_coundnt_hear: {
            value: false,
            title: 'call-quality-survey.audio.people-hear',
        },
        i_coundnt_hear: {
            value: false,
            title: 'call-quality-survey.audio.i-cant-hear',
        },
    },
    features: {
        my_share: {
            value: false,
            title: 'call-quality-survey.features.my-share',
        },
        other_share: {
            value: false,
            title: 'call-quality-survey.features.other-share',
        },
        pip: { value: false, title: 'call-quality-survey.features.pip' },
        chat: { value: false, title: 'call-quality-survey.features.chat' },
        group_call: {
            value: false,
            title: 'call-quality-survey.features.group',
        },
    },
};
export const SurveyTabs = [
    SurveyTab.Video,
    SurveyTab.Audio,
    SurveyTab.Features,
    SurveyTab.Other,
];
export const RatingStars = [
    {
        label: SurveyStarLabel.VeryPoor,
        value: SurveyStarValue.VeryPoor,
    },
    {
        label: SurveyStarLabel.Poor,
        value: SurveyStarValue.Poor,
    },
    {
        label: SurveyStarLabel.Average,
        value: SurveyStarValue.Average,
    },
    {
        label: SurveyStarLabel.Good,
        value: SurveyStarValue.Good,
    },
    {
        label: SurveyStarLabel.Great,
        value: SurveyStarValue.Great,
    },
];
